import React, { useEffect } from 'react';
import { cashinStatus } from '@/mytickets/constants/cashinStatus';
import CashinStatus from './CashinStatus';
import CashinPaidOut from './CashinPaidOut';
import CashinRejection from './CashinRejection';
import { dispatch } from 'nike-re-framejs';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';

function ActiveCashinDialog({ cashinTransaction, closeDialogSuccess, closeDialogFailed }) {
    useEffect(() => {
        // tento effect asi netraba, lebo mame funkciu closeClosingModeOnCurrentDevice, ktora sa vola v ramci onCashinOfferPushEvent
        if (cashinTransaction.get('status') === cashinStatus.Approved) {
            dispatch(clearCashinClosingMode);
        }
    }, [cashinTransaction]);

    let content;
    switch (cashinTransaction.get('status')) {
        case cashinStatus.Started:
        case cashinStatus.Activated:
        case cashinStatus.AuthorizationRequired:
            content = <CashinStatus cashinTransaction={cashinTransaction} />;
            break;
        case cashinStatus.Acked:
        case cashinStatus.PaidOut:
        case cashinStatus.Approved:
            content = <CashinPaidOut cashinTransaction={cashinTransaction} closeDialog={closeDialogSuccess} />;
            break;

        case cashinStatus.Rejected:
            content = <CashinRejection cashinTransaction={cashinTransaction} closeDialog={closeDialogFailed} />;
            break;
        default:
            return null;
    }
    return <div className="cashin-popup-info">{content}</div>;
}

export default ActiveCashinDialog;
